import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { usePermanentAppState } from '@ms/yammer-modules-townhall-event';
import { getEventBroadcastDataFromPath } from '@ms/yammer-web-support/dist/location';
import type { FC } from 'react';
import React, { useEffect } from 'react';

import App from '../App';
import AppLiveEvent from '../AppLiveEvent';

const Main: FC = () => {
  const canRenderLiveEventsApp = useExperimentTreatmentWithoutReporting('LiveEventsScaleLoadPerf') === true;
  const hasBroadcastData = getEventBroadcastDataFromPath(window.location.pathname) !== undefined;
  const { permanentApp, setPermanentApp } = usePermanentAppState();

  useEffect(() => {
    if (!permanentApp) {
      setPermanentApp(hasBroadcastData && canRenderLiveEventsApp ? 'AppLiveEvent' : 'App');
    }
  }, [hasBroadcastData, canRenderLiveEventsApp, permanentApp, setPermanentApp]);

  if (permanentApp === 'AppLiveEvent') {
    return <AppLiveEvent />;
  }

  if (permanentApp === 'App') {
    return <App />;
  }

  return null;
};

export default Main;
